import Select from 'react-select'
import { FormSelectProps } from '../../../models'

/**
 * Wrapper generico sobre react-select (sincrono).
 * Renderiza label + Select + mensaje de error desde react-hook-form.
 * Soporta seleccion multiple (isMulti), custom Option renderer y estilos personalizados.
 */
export const FormSelect = <TFormValues extends Record<string, unknown>>({
  elementos,
  placeholder,
  onChange,
  nombre,
  defaultValue,
  className,
  isObligatorio,
  Componente,
  value,
  errors,
  isClearable = true,
  isSearchable = true,
  nombreCampo,
  autoFocus,
  isDisabled,
  isMulti = false,
  closeMenuOnScroll,
}: FormSelectProps<TFormValues>) => {
  return (
    <div className={className}>
      {nombre && (
        <label className='form-label fs-4'>
          {nombre} {isObligatorio && <span className='text-danger'>*</span>}
        </label>
      )}
      <Select
        menuPortalTarget={document.body}
        autoFocus={autoFocus}
        isDisabled={isDisabled}
        key={`_${value}`}
        styles={customStyles}
        aria-label={nombre}
        className='form-select-autocomplete'
        isClearable={isClearable}
        defaultValue={defaultValue}
        onChange={onChange}
        getOptionLabel={(option) => option.etiqueta}
        getOptionValue={(option) => option.valor}
        options={elementos}
        placeholder={placeholder}
        menuPosition='fixed'
        noOptionsMessage={() => 'No se encontraron coincidencias'}
        components={{ Option: Componente || Opcion }}
        value={value}
        isMulti={isMulti}
        isSearchable={isSearchable}
        required={isObligatorio}
        closeMenuOnScroll={closeMenuOnScroll}
      />
      {errors && errors[nombreCampo] && (
        <p className='text-danger text-end fs-5'>{errors[nombreCampo]?.message}</p>
      )}
    </div>
  )
}

export const Opcion = (props: any) => {
  const { innerProps, innerRef, isSelected, isFocused } = props
  return (
    <div
      ref={innerRef}
      {...innerProps}
      className='custom-select p-3 '
      style={{
        backgroundColor: isSelected ? '#ffd5c4' : isFocused ? '#ffe7e2' : '#f5f8fa',
      }}>
      {props.data.color ? (
        <div className='d-flex'>
          <span
            className={` mb-1 mx-2 mt-2 align-items-center bullet bullet-dot h-10px w-10px badge-${props.data.color}
                                        `}></span>
          <p>{props.data.etiqueta}</p>
        </div>
      ) : (
        <p>{props.data.etiqueta}</p>
      )}
    </div>
  )
}
const padding = '0 !important'

export const customStyles = {
  menu: (provided: any) => ({
    ...provided,
    marginTop: '.2rem',
    paddingTop: padding,
    zIndex: 9999,
  }),
  valueContainer: (provided: any) => ({
    ...provided,
    paddingRight: padding,
  }),
  menuList: (provided: any) => ({
    ...provided,
    padding: padding,
  }),
  control: (provided: any) => ({
    ...provided,
    border: '1px solid #f5f8fa',
    backgroundColor: '#f5f8fa',
    padding: '.2rem 0',
    transition: 'all .5s ease',
    boxShadow: 'none',
    '&:hover': {
      border: '1px solid #ffc1a8',
    },
  }),
  singleValue: (provided: any) => {
    return { ...provided, padding: '0 .2rem', color: '#5E6278' }
  },
  indicatorsContainer: (provided: any) => ({
    ...provided,
    padding: padding,
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    color: '#5E6278',
    backgroundColor: state.isSelected ? '#ffd5c4' : '#f5f8fa',
    fontFamily: 'TheSans',
    '&:hover': {
      backgroundColor: '#ffe7e2',
    },
  }),
  placeholder: (provided: any) => {
    return {
      ...provided,
      color: '#A1A5B7',
    }
  },
  multiValue: (provided: any) => {
    return { ...provided, color: 'hsl(0, 0%, 80%)' }
  },
  multiValueLabel: (provided: any) => {
    return { ...provided, fontSize: '1.1rem', color: '#5E6278' }
  },
  menuPortal: (provided: any) => {
    return { ...provided, zIndex: 9999 }
  },
}
